<template>
  <section v-if="isHomeRoute" class="home-doodle shell-section">
    <div class="home-doodle__frame shell-surface">
      <div class="home-doodle__media">
        <video autoplay muted playsinline loop src="../assets/vidFomo.mp4"></video>
      </div>

      <div class="home-doodle__veil"></div>
      <div class="home-doodle__grid"></div>
      <div class="home-doodle__ambient home-doodle__ambient--one"></div>
      <div class="home-doodle__ambient home-doodle__ambient--two"></div>

      <div :class="['home-doodle__scene', { 'is-three-ready': heroSceneReady }]" aria-hidden="true">
        <canvas ref="heroCanvas" class="home-doodle__scene-canvas"></canvas>
        <div class="home-doodle__scene-aura home-doodle__scene-aura--cyan"></div>
        <div class="home-doodle__scene-aura home-doodle__scene-aura--violet"></div>
        <div class="home-doodle__scene-ribbons">
          <span class="home-doodle__scene-ribbon home-doodle__scene-ribbon--one"></span>
          <span class="home-doodle__scene-ribbon home-doodle__scene-ribbon--two"></span>
          <span class="home-doodle__scene-ribbon home-doodle__scene-ribbon--three"></span>
        </div>
        <div class="home-doodle__scene-bars">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="home-doodle__scene-orbital">
          <span class="home-doodle__scene-orbit home-doodle__scene-orbit--outer"></span>
          <span class="home-doodle__scene-orbit home-doodle__scene-orbit--inner"></span>
          <span class="home-doodle__scene-core"></span>
          <span class="home-doodle__scene-satellite home-doodle__scene-satellite--one"></span>
          <span class="home-doodle__scene-satellite home-doodle__scene-satellite--two"></span>
        </div>
        <div class="home-doodle__scene-beam"></div>
        <div class="home-doodle__scene-tickets">
          <article class="home-doodle__scene-ticket home-doodle__scene-ticket--back">
            <span class="home-doodle__scene-ticket-line home-doodle__scene-ticket-line--strong"></span>
            <span class="home-doodle__scene-ticket-line"></span>
            <span class="home-doodle__scene-ticket-line home-doodle__scene-ticket-line--short"></span>
          </article>

          <article class="home-doodle__scene-ticket home-doodle__scene-ticket--front">
            <span class="home-doodle__scene-ticket-line home-doodle__scene-ticket-line--strong"></span>
            <span class="home-doodle__scene-ticket-line"></span>
            <span class="home-doodle__scene-ticket-line home-doodle__scene-ticket-line--short"></span>
            <div class="home-doodle__scene-qr-shell">
              <div class="home-doodle__scene-qr-panel">
                <span
                  v-for="module in qrModules"
                  :key="`fallback-${module.key}`"
                  class="home-doodle__scene-qr-module"
                  :style="{ left: `${module.x - 120}px`, top: `${module.y - 192}px` }"
                ></span>
                <span class="home-doodle__scene-qr-scan"></span>
              </div>
            </div>
          </article>
        </div>
        <div class="home-doodle__scene-sparks">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="home-doodle__scene-fade"></div>
      </div>

      <div class="home-doodle__content">
        <span class="home-doodle__eyebrow">FOMO PLANES</span>
        <h1 class="home-doodle__title">
          <span class="home-doodle__title-line">Hay dos clases</span>
          <span class="home-doodle__title-line">de planes.</span>
        </h1>
        <p class="home-doodle__statement">
          <span class="home-doodle__statement-line">{{ primaryStatementLine }}</span>
          <span v-if="!isMobileViewport" class="home-doodle__statement-line">y los demás.</span>
        </p>
        <p class="home-doodle__subtitle">{{ homeSubtitle }}</p>

        <div class="home-doodle__meta">
          <span class="home-doodle__meta-pill">{{ activeEventsLabel }}</span>
          <span v-if="!isMobileViewport" class="home-doodle__meta-pill">Listas y entradas</span>
        </div>

        <div class="home-doodle__actions">
          <button class="home-doodle__action home-doodle__action--primary" type="button" @click="scrollToEvents">
            <span class="home-doodle__action-glow"></span>
            <span class="home-doodle__action-ring"></span>
            <span class="home-doodle__action-inner">
              <span class="home-doodle__action-copy">{{ primaryActionLabel }}</span>
              <span class="home-doodle__action-icon">
                <i class="fas fa-arrow-right"></i>
              </span>
            </span>
          </button>

          <button class="home-doodle__action home-doodle__action--secondary" type="button" @click="openWss">
            <span class="home-doodle__action-glow"></span>
            <span class="home-doodle__action-ring"></span>
            <span class="home-doodle__action-inner">
              <span class="home-doodle__action-copy">{{ secondaryActionLabel }}</span>
              <span class="home-doodle__action-icon">
                <i class="fas fa-calendar-alt"></i>
              </span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import * as THREE from 'three'

export default {
  name: 'SlideShow',

  props: {
    main: {
      required: false,
    },
    subtitle: {
      required: false,
    },
    type: {
      default: 2,
    },
    activeEventsCount: {
      type: Number,
      required: false,
      default: null,
    },
  },

  computed: {
    isHomeRoute() {
      return this.$route.name === 'home'
    },

    isMobileViewport() {
      return this.viewportWidth <= 720
    },

    homeSubtitle() {
      if (this.isMobileViewport) {
        return 'Entradas y listas activas para decidir rapido.'
      }

      return this.subtitle || 'Entradas, listas y experiencias curadas en un solo lugar.'
    },

    activeEventsLabel() {
      if (this.activeEventsCount && this.activeEventsCount > 0) {
        return this.activeEventsCount === 1 ? '1 evento activo' : `${this.activeEventsCount} eventos activos`
      }

      return 'Seleccion en vivo'
    },

    primaryStatementLine() {
      return this.isMobileViewport ? 'Los que se venden en FOMO y los demás.' : 'Los que se venden en FOMO'
    },

    primaryActionLabel() {
      return this.isMobileViewport ? 'Ver eventos' : 'Explorar eventos'
    },

    secondaryActionLabel() {
      return this.isMobileViewport ? 'Crear evento' : 'Lanza tu evento'
    },

    qrModules() {
      return [
        '0001011001010',
        '1010110010101',
        '0011010101100',
        '1100100110010',
        '0101110001011',
        '1010001110100',
        '0011100101010',
        '1100011010001',
        '0110100101100',
        '1001011010010',
        '0100110101010',
        '1011001010110',
        '0010101100101',
      ].flatMap((row, rowIndex) => row.split('').flatMap((cell, colIndex) => {
        if (cell !== '1') {
          return []
        }

        return {
          key: `${rowIndex}-${colIndex}`,
          x: 120 + (colIndex * 5.4),
          y: 192 + (rowIndex * 5.4),
        }
      }))
    },

  },

  data() {
    return {
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1280,
      heroScene: null,
      heroSceneReady: false,
      handleViewportResize: null,
      runHeroAnimation: null,
      prefersReducedMotion: false,
    }
  },

  watch: {
    isHomeRoute() {
      this.$nextTick(() => {
        this.handleViewportSceneChange()
      })
    },
  },

  mounted() {
    this.prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    this.handleViewportResize = this.handleViewportSceneChange.bind(this)
    this.runHeroAnimation = this.animateHeroScene.bind(this)
    window.addEventListener('resize', this.handleViewportResize)
    this.$nextTick(() => {
      this.handleViewportSceneChange()
    })
  },

  beforeUnmount() {
    if (this.handleViewportResize) {
      window.removeEventListener('resize', this.handleViewportResize)
    }
    this.teardownHeroScene()
  },

  methods: {
    handleViewportSceneChange() {
      this.viewportWidth = window.innerWidth || 1280

      if (!this.isHomeRoute) {
        this.teardownHeroScene()
        return
      }

      if (!this.heroScene && this.$refs.heroCanvas) {
        try {
          this.setupHeroScene()
        } catch (error) {
          console.warn('[SlideShow] Three.js init failed, using CSS fallback:', error)
          this.heroSceneReady = false
        }
        return
      }

      if (this.heroScene) {
        this.handleHeroSceneResize()
      }
    },

    setupHeroScene() {
      if (!this.isHomeRoute || !this.$refs.heroCanvas || this.heroScene) {
        return
      }

      this.heroSceneReady = false

      const canvas = this.$refs.heroCanvas
      const isMobile = this.viewportWidth <= 720

      // Check WebGL availability before attempting to create the renderer
      const testCanvas = document.createElement('canvas')
      const gl = testCanvas.getContext('webgl2') || testCanvas.getContext('webgl') || testCanvas.getContext('experimental-webgl')
      if (!gl) {
        console.warn('[SlideShow] WebGL not available, using CSS fallback')
        return
      }

      const scene = new THREE.Scene()
      const camera = new THREE.PerspectiveCamera(34, 1, 0.1, 60)
      const renderer = new THREE.WebGLRenderer({
        canvas,
        antialias: !isMobile,
        alpha: true,
        powerPreference: isMobile ? 'default' : 'high-performance',
      })

      // Handle WebGL context lost — revert to CSS fallback
      canvas.addEventListener('webglcontextlost', (event) => {
        event.preventDefault()
        console.warn('[SlideShow] WebGL context lost, reverting to CSS fallback')
        this.teardownHeroScene()
      }, false)

      canvas.addEventListener('webglcontextrestored', () => {
        console.info('[SlideShow] WebGL context restored, re-initialising scene')
        this.$nextTick(() => { this.handleViewportSceneChange() })
      }, false)

      renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, isMobile ? 1.15 : 1.8))
      renderer.outputColorSpace = THREE.SRGBColorSpace
      renderer.toneMapping = THREE.ACESFilmicToneMapping
      renderer.toneMappingExposure = 1.18
      renderer.setClearColor(0x000000, 0)

      const root = new THREE.Group()
      root.position.set(0.7, -0.08, 0)
      scene.add(root)

      const ambient = new THREE.AmbientLight(0xdbe7ff, 0.76)
      const cyanLight = new THREE.PointLight(0x74e0ff, 8.4, 42, 2.2)
      cyanLight.position.set(-3.4, 1.8, 8)
      const violetLight = new THREE.PointLight(0xa67cff, 7.6, 42, 2.2)
      violetLight.position.set(4.8, -0.2, 7)
      const softLight = new THREE.PointLight(0xffffff, 3.6, 26, 2)
      softLight.position.set(1.4, 3.2, 5.4)
      scene.add(ambient, cyanLight, violetLight, softLight)

      const particleGeometry = new THREE.BufferGeometry()
      const particleCount = isMobile ? 180 : 460
      const particlePositions = new Float32Array(particleCount * 3)
      const particleSizes = new Float32Array(particleCount)

      for (let index = 0; index < particleCount; index += 1) {
        const i3 = index * 3
        particlePositions[i3] = THREE.MathUtils.randFloatSpread(18)
        particlePositions[i3 + 1] = THREE.MathUtils.randFloatSpread(12)
        particlePositions[i3 + 2] = THREE.MathUtils.randFloat(-7, 4)
        particleSizes[index] = THREE.MathUtils.randFloat(0.14, 0.42)
      }

      particleGeometry.setAttribute('position', new THREE.BufferAttribute(particlePositions, 3))
      particleGeometry.setAttribute('size', new THREE.BufferAttribute(particleSizes, 1))

      const particleMaterial = new THREE.PointsMaterial({
        color: 0xdde9ff,
        size: 0.065,
        transparent: true,
        opacity: 0.34,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        sizeAttenuation: true,
      })

      const particles = new THREE.Points(particleGeometry, particleMaterial)
      particles.position.set(0.4, 0.2, -3.4)
      scene.add(particles)

      const ribbons = new THREE.Group()
      root.add(ribbons)

      const ribbonCurves = [
        [
          new THREE.Vector3(-4.6, 1.2, -1.5),
          new THREE.Vector3(-2.4, 0.6, -0.6),
          new THREE.Vector3(0.2, 0.4, 0.2),
          new THREE.Vector3(2.8, 0.9, 0.9),
          new THREE.Vector3(5.3, 1.7, 1.2),
        ],
        [
          new THREE.Vector3(-4.2, 0.2, -1.2),
          new THREE.Vector3(-1.9, -0.2, -0.2),
          new THREE.Vector3(0.8, -0.1, 0.4),
          new THREE.Vector3(3.4, 0.3, 0.8),
          new THREE.Vector3(5.6, 0.9, 1),
        ],
        [
          new THREE.Vector3(-3.7, -0.9, -1),
          new THREE.Vector3(-1.2, -1.1, -0.2),
          new THREE.Vector3(1.2, -0.8, 0.2),
          new THREE.Vector3(3.6, -0.4, 0.6),
          new THREE.Vector3(5.5, 0.2, 0.9),
        ],
      ]

      const ribbonConfigs = [
        { color: 0x7fe2ff, radius: 0.14, opacity: 0.42 },
        { color: 0x8d74ff, radius: 0.09, opacity: 0.3 },
        { color: 0xe8f0ff, radius: 0.05, opacity: 0.2 },
      ]

      ribbonCurves.forEach((points, index) => {
        const curve = new THREE.CatmullRomCurve3(points)
        const geometry = new THREE.TubeGeometry(curve, 140, ribbonConfigs[index].radius, 12, false)
        const material = new THREE.MeshBasicMaterial({
          color: ribbonConfigs[index].color,
          transparent: true,
          opacity: ribbonConfigs[index].opacity,
          blending: THREE.AdditiveBlending,
          depthWrite: false,
        })
        const mesh = new THREE.Mesh(geometry, material)
        ribbons.add(mesh)
      })

      const barsGroup = new THREE.Group()
      barsGroup.position.set(-2.6, 1.1, 0.5)
      root.add(barsGroup)

      const bars = []
      ;[1.3, 1.95, 1.5, 2.25, 1.7].forEach((height, index) => {
        const material = new THREE.MeshStandardMaterial({
          color: 0xdce8ff,
          emissive: new THREE.Color(index % 2 === 0 ? 0x79def1 : 0x91b8ff),
          emissiveIntensity: 0.44,
          roughness: 0.18,
          metalness: 0.3,
          transparent: true,
          opacity: 0.88,
        })
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(0.16, height, 0.16), material)
        mesh.position.set(index * 0.38, height * 0.5, 0)
        mesh.userData.baseHeight = height
        barsGroup.add(mesh)
        bars.push(mesh)
      })

      const orbitalGroup = new THREE.Group()
      orbitalGroup.position.set(2.7, 1.5, 0.6)
      root.add(orbitalGroup)

      const orbitOuter = new THREE.Mesh(
        new THREE.TorusGeometry(1.55, 0.022, 16, 180),
        new THREE.MeshBasicMaterial({
          color: 0xd8e4f4,
          transparent: true,
          opacity: 0.46,
          depthWrite: false,
        }),
      )

      const orbitInner = new THREE.Mesh(
        new THREE.TorusGeometry(0.94, 0.018, 16, 180),
        new THREE.MeshBasicMaterial({
          color: 0xc8d4e8,
          transparent: true,
          opacity: 0.4,
          depthWrite: false,
        }),
      )
      orbitInner.rotation.x = Math.PI * 0.18

      const orbitGlow = new THREE.Mesh(
        new THREE.TorusGeometry(1.18, 0.22, 24, 180),
        new THREE.MeshBasicMaterial({
          color: 0x9d7cff,
          transparent: true,
          opacity: 0.28,
          blending: THREE.AdditiveBlending,
          depthWrite: false,
        }),
      )

      const core = new THREE.Mesh(
        new THREE.IcosahedronGeometry(0.34, 4),
        new THREE.MeshStandardMaterial({
          color: 0xf2f7ff,
          emissive: 0xb9d9ff,
          emissiveIntensity: 1.8,
          roughness: 0.12,
          metalness: 0.28,
        }),
      )

      const satelliteOne = new THREE.Mesh(
        new THREE.SphereGeometry(0.14, 24, 24),
        new THREE.MeshBasicMaterial({ color: 0xe7eef8, transparent: true, opacity: 0.56 }),
      )

      const satelliteTwo = new THREE.Mesh(
        new THREE.SphereGeometry(0.08, 24, 24),
        new THREE.MeshBasicMaterial({ color: 0xd7e2f0, transparent: true, opacity: 0.4 }),
      )

      orbitalGroup.add(orbitGlow, orbitOuter, orbitInner, core, satelliteOne, satelliteTwo)

      const beamTexture = this.createBeamTexture()
      const beamMaterial = new THREE.MeshBasicMaterial({
        map: beamTexture,
        transparent: true,
        opacity: 0.9,
        blending: THREE.AdditiveBlending,
        depthWrite: false,
      })
      const beam = new THREE.Mesh(new THREE.PlaneGeometry(2.6, 4.8), beamMaterial)
      beam.position.set(1.3, -0.42, -0.6)
      beam.rotation.set(0.16, 0.04, 0.74)
      root.add(beam)

      const ticketsGroup = new THREE.Group()
      ticketsGroup.position.set(0.72, -1.52, 0.5)
      root.add(ticketsGroup)

      const backTicketMaterial = new THREE.MeshStandardMaterial({
        map: this.createTicketTexture({ mode: 'back' }),
        transparent: true,
        roughness: 0.24,
        metalness: 0.12,
      })

      const frontTicketMaterial = new THREE.MeshStandardMaterial({
        map: this.createTicketTexture({ mode: 'front' }),
        transparent: true,
        roughness: 0.18,
        metalness: 0.14,
      })

      const backTicket = new THREE.Mesh(new THREE.PlaneGeometry(3.45, 2.18), backTicketMaterial)
      backTicket.position.set(-0.45, 0.52, -0.4)
      backTicket.rotation.z = -0.22

      const frontTicket = new THREE.Mesh(new THREE.PlaneGeometry(3.55, 2.24), frontTicketMaterial)
      frontTicket.position.set(0.46, -0.08, 0.28)
      frontTicket.rotation.z = 0.16

      ticketsGroup.add(backTicket, frontTicket)

      const sparks = []
      ;[
        { position: new THREE.Vector3(-0.1, -2.1, 0.2), scale: 0.12 },
        { position: new THREE.Vector3(0.52, -1.56, 0.35), scale: 0.08 },
        { position: new THREE.Vector3(2.1, -2.4, 0.1), scale: 0.1 },
      ].forEach((sparkConfig) => {
        const spark = new THREE.Mesh(
          new THREE.SphereGeometry(sparkConfig.scale, 16, 16),
          new THREE.MeshBasicMaterial({ color: 0xe9f1fb, transparent: true, opacity: 0.68 }),
        )
        spark.position.copy(sparkConfig.position)
        root.add(spark)
        sparks.push(spark)
      })

      this.heroScene = {
        canvas,
        scene,
        camera,
        renderer,
        root,
        ribbons,
        bars,
        orbitalGroup,
        orbitInner,
        beam,
        beamMaterial,
        satelliteOne,
        satelliteTwo,
        ticketsGroup,
        frontTicket,
        backTicket,
        particles,
        sparks,
        clock: new THREE.Clock(),
        animationFrame: null,
      }

      this.handleHeroSceneResize()
      this.heroSceneReady = true
      this.animateHeroScene()
    },

    createBeamTexture() {
      const canvas = document.createElement('canvas')
      canvas.width = 256
      canvas.height = 1024

      const context = canvas.getContext('2d')
      const gradient = context.createLinearGradient(0, 0, 0, canvas.height)
      gradient.addColorStop(0, 'rgba(239,243,255,0.62)')
      gradient.addColorStop(0.2, 'rgba(206,230,255,0.42)')
      gradient.addColorStop(0.54, 'rgba(115,216,241,0.26)')
      gradient.addColorStop(1, 'rgba(115,216,241,0)')

      context.fillStyle = gradient
      context.fillRect(0, 0, canvas.width, canvas.height)

      const texture = new THREE.CanvasTexture(canvas)
      texture.colorSpace = THREE.SRGBColorSpace
      return texture
    },

    createTicketTexture({ mode }) {
      const canvas = document.createElement('canvas')
      canvas.width = 1200
      canvas.height = 760

      const context = canvas.getContext('2d')
      const ticketWidth = 1060
      const ticketHeight = 660
      const x = 70
      const y = 50
      const radius = 74

      context.clearRect(0, 0, canvas.width, canvas.height)
      context.save()
      this.drawRoundedRect(context, x, y, ticketWidth, ticketHeight, radius)
      const shellGradient = context.createLinearGradient(x, y, x + ticketWidth, y + ticketHeight)
      shellGradient.addColorStop(0, mode === 'front' ? '#151a29' : '#121723')
      shellGradient.addColorStop(0.52, '#090d14')
      shellGradient.addColorStop(1, mode === 'front' ? '#17172c' : '#12131f')
      context.fillStyle = shellGradient
      context.fill()
      context.lineWidth = 4
      context.strokeStyle = 'rgba(213, 220, 232, 0.18)'
      context.stroke()
      context.restore()

      const highlight = context.createLinearGradient(x, y, x, y + ticketHeight)
      highlight.addColorStop(0, 'rgba(255,255,255,0.14)')
      highlight.addColorStop(0.28, 'rgba(255,255,255,0)')
      context.fillStyle = highlight
      this.drawRoundedRect(context, x + 4, y + 4, ticketWidth - 8, ticketHeight - 8, radius - 10)
      context.fill()

      const textBaseY = y + 126
      context.fillStyle = 'rgba(241,245,251,0.86)'
      context.fillRect(x + 94, textBaseY, 250, 24)
      context.fillStyle = 'rgba(201,210,223,0.32)'
      context.fillRect(x + 94, textBaseY + 48, 180, 16)
      context.fillRect(x + 94, textBaseY + 82, 224, 16)

      if (mode === 'front') {
        context.fillStyle = 'rgba(255,255,255,0.12)'
        context.fillRect(x + 102, textBaseY - 20, 232, 10)
      }

      const qrShellX = x + 626
      const qrShellY = y + 188
      const qrShellSize = 286
      context.save()
      this.drawRoundedRect(context, qrShellX, qrShellY, qrShellSize, qrShellSize, 44)
      context.fillStyle = 'rgba(13, 17, 24, 0.84)'
      context.fill()
      context.strokeStyle = 'rgba(214,223,236,0.16)'
      context.lineWidth = 4
      context.stroke()
      context.restore()

      const qrPanelInset = 34
      const qrPanelX = qrShellX + qrPanelInset
      const qrPanelY = qrShellY + qrPanelInset
      const qrPanelSize = qrShellSize - (qrPanelInset * 2)
      context.fillStyle = 'rgba(5,8,14,0.96)'
      this.drawRoundedRect(context, qrPanelX, qrPanelY, qrPanelSize, qrPanelSize, 30)
      context.fill()

      context.fillStyle = '#dde4ef'
      this.qrModules.forEach((module) => {
        context.fillRect(qrPanelX + (module.x - 120) * 1.72, qrPanelY + (module.y - 192) * 1.72, 9, 9)
      })

      context.fillStyle = 'rgba(235,240,247,0.92)'
      context.fillRect(qrPanelX, qrPanelY + 16, qrPanelSize, 5)

      const texture = new THREE.CanvasTexture(canvas)
      texture.colorSpace = THREE.SRGBColorSpace
      return texture
    },

    drawRoundedRect(context, x, y, width, height, radius) {
      context.beginPath()
      context.moveTo(x + radius, y)
      context.arcTo(x + width, y, x + width, y + height, radius)
      context.arcTo(x + width, y + height, x, y + height, radius)
      context.arcTo(x, y + height, x, y, radius)
      context.arcTo(x, y, x + width, y, radius)
      context.closePath()
    },

    handleHeroSceneResize() {
      if (!this.heroScene) {
        return
      }

      const width = this.heroScene.canvas.clientWidth || 1
      const height = this.heroScene.canvas.clientHeight || 1
      const isMobile = window.innerWidth <= 720
      const isTablet = window.innerWidth <= 1100

      this.heroScene.renderer.setSize(width, height, false)
      this.heroScene.camera.aspect = width / height
      this.heroScene.camera.updateProjectionMatrix()

      if (isMobile) {
        this.heroScene.camera.position.set(0, 0.02, 13.4)
        this.heroScene.root.position.set(0.24, -0.12, 0)
        this.heroScene.root.scale.setScalar(0.92)
      } else if (isTablet) {
        this.heroScene.camera.position.set(0, 0, 11.6)
        this.heroScene.root.position.set(0.46, -0.06, 0)
        this.heroScene.root.scale.setScalar(1.04)
      } else {
        this.heroScene.camera.position.set(0, 0, 10.8)
        this.heroScene.root.position.set(0.56, -0.04, 0)
        this.heroScene.root.scale.setScalar(1.14)
      }

      this.heroScene.camera.lookAt(this.heroScene.root.position.x, this.heroScene.root.position.y, 0)
    },

    animateHeroScene() {
      if (!this.heroScene) {
        return
      }

      const {
        clock,
        renderer,
        scene,
        camera,
        ribbons,
        bars,
        orbitalGroup,
        orbitInner,
        beam,
        beamMaterial,
        satelliteOne,
        satelliteTwo,
        ticketsGroup,
        frontTicket,
        backTicket,
        particles,
        sparks,
      } = this.heroScene

      const motionMultiplier = this.prefersReducedMotion ? 0.28 : 1
      const time = clock.getElapsedTime() * motionMultiplier

      ribbons.children.forEach((ribbon, index) => {
        ribbon.rotation.z = (Math.sin((time * 0.28) + index) * 0.05) - (0.06 * index)
        ribbon.position.y = Math.sin((time * 0.36) + (index * 0.9)) * 0.08
      })

      bars.forEach((bar, index) => {
        const scale = 0.84 + Math.sin((time * 2.1) + (index * 0.58)) * 0.2
        bar.scale.y = scale
      })

      orbitalGroup.rotation.z = time * 0.18
      orbitInner.rotation.x = (Math.PI * 0.18) + (Math.sin(time * 0.5) * 0.12)
      satelliteOne.position.set(Math.cos(time * 0.92) * 1.84, Math.sin(time * 0.92) * 1.1, 0)
      satelliteTwo.position.set(Math.cos((time * 1.18) + 2.2) * 1.18, Math.sin((time * 1.18) + 2.2) * 1.58, 0)

      beam.rotation.z = 0.72 + (Math.sin(time * 0.52) * 0.04)
      beamMaterial.opacity = 0.48 + (Math.sin(time * 1.6) * 0.12)

      ticketsGroup.rotation.z = Math.sin(time * 0.26) * 0.04
      backTicket.rotation.z = -0.22 + (Math.sin(time * 0.72) * 0.04)
      backTicket.position.y = 0.5 + (Math.cos(time * 0.8) * 0.08)
      frontTicket.rotation.z = 0.16 + (Math.sin((time * 0.82) + 1.4) * 0.05)
      frontTicket.position.y = Math.sin((time * 0.9) + 0.6) * 0.1
      frontTicket.position.x = 0.44 + (Math.sin(time * 0.56) * 0.04)

      particles.rotation.y = time * 0.02
      particles.rotation.z = Math.sin(time * 0.12) * 0.04

      sparks.forEach((spark, index) => {
        const pulse = 0.78 + Math.sin((time * 2.2) + (index * 0.9)) * 0.34
        spark.scale.setScalar(pulse)
      })

      renderer.render(scene, camera)
      this.heroScene.animationFrame = window.requestAnimationFrame(this.runHeroAnimation)
    },

    teardownHeroScene() {
      if (!this.heroScene) {
        return
      }

      if (this.heroScene.animationFrame) {
        window.cancelAnimationFrame(this.heroScene.animationFrame)
      }

      this.heroScene.scene.traverse((child) => {
        if (child.geometry) {
          child.geometry.dispose()
        }

        if (child.material) {
          const materials = Array.isArray(child.material) ? child.material : [child.material]
          materials.forEach((material) => {
            if (material.map) {
              material.map.dispose()
            }
            material.dispose()
          })
        }
      })

      this.heroScene.renderer.dispose()
      this.heroScene = null
      this.heroSceneReady = false
    },

    scrollToEvents() {
      const section = document.getElementById('agenda-activa')

      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },

    openWss() {
      this.$router.push({ name: 'launch-event' })
    },
  },
}
</script>

<style scoped>
.home-doodle {
  padding-top: 6px;
  padding-bottom: 10px;
}

.home-doodle__frame {
  position: relative;
  overflow: hidden;
  min-height: clamp(420px, 52vw, 580px);
  padding: clamp(22px, 2.6vw, 30px);
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.018), rgba(255, 255, 255, 0.006)),
    rgba(5, 5, 9, 0.9) !important;
}

.home-doodle__frame::before,
.home-doodle__frame::after {
  content: '';
  position: absolute;
  pointer-events: none;
}

.home-doodle__frame::before {
  inset: -14% auto auto -8%;
  width: 340px;
  height: 340px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(74, 134, 150, 0.24), transparent 72%);
  filter: blur(46px);
}

.home-doodle__frame::after {
  inset: 12px;
  border-radius: calc(var(--radius-xl) - 14px);
  border: 1px solid rgba(205, 210, 223, 0.05);
}

.home-doodle__media,
.home-doodle__media video,
.home-doodle__veil,
.home-doodle__grid,
.home-doodle__ambient {
  position: absolute;
  inset: 0;
}

.home-doodle__media video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.03);
  filter: saturate(0.82) brightness(0.42) contrast(1.08);
}

.home-doodle__veil {
  background:
    radial-gradient(circle at 18% 18%, rgba(76, 140, 156, 0.18), transparent 22%),
    radial-gradient(circle at 78% 38%, rgba(121, 219, 239, 0.12), transparent 26%),
    linear-gradient(98deg, rgba(5, 5, 9, 0.66) 8%, rgba(7, 6, 13, 0.32) 34%, rgba(7, 6, 13, 0.08) 58%, rgba(5, 5, 9, 0.7) 100%);
}

.home-doodle__grid {
  opacity: 0.18;
  background-image:
    linear-gradient(rgba(208, 216, 232, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(208, 216, 232, 0.08) 1px, transparent 1px);
  background-size: 84px 84px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.6), transparent 100%);
}

.home-doodle__ambient--one {
  background: radial-gradient(circle at 74% 34%, rgba(218, 225, 236, 0.12), transparent 12%);
  filter: blur(24px);
}

.home-doodle__ambient--two {
  background: radial-gradient(circle at 66% 70%, rgba(83, 152, 166, 0.22), transparent 26%);
  filter: blur(24px);
}

.home-doodle__scene {
  position: absolute;
  top: 50%;
  right: clamp(-18px, -1vw, 10px);
  bottom: auto;
  width: min(56%, 860px);
  height: auto;
  aspect-ratio: 760 / 560;
  pointer-events: none;
  opacity: 1;
  transform: translateY(-50%);
  filter: drop-shadow(0 36px 62px rgba(0, 0, 0, 0.28));
  mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 6%, rgba(0, 0, 0, 0.78) 22%, #000 38%);
  -webkit-mask-image: linear-gradient(90deg, transparent 0%, rgba(0, 0, 0, 0.08) 6%, rgba(0, 0, 0, 0.78) 22%, #000 38%);
  perspective: 1600px;
  z-index: 1;
}

.home-doodle__scene-canvas,
.home-doodle__scene-fade {
  position: absolute;
  inset: 0;
}

.home-doodle__scene-static {
  position: absolute;
  inset: 0;
}

.home-doodle__scene-canvas {
  display: block;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.home-doodle__scene-fade {
  background:
    radial-gradient(circle at 72% 28%, rgba(255, 255, 255, 0.06), transparent 18%),
    radial-gradient(circle at 62% 42%, rgba(111, 229, 245, 0.12), transparent 22%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.04), transparent 22%, rgba(5, 7, 11, 0.08) 100%);
  pointer-events: none;
  mix-blend-mode: screen;
  z-index: 5;
}

.home-doodle__scene-aura,
.home-doodle__scene-ribbons,
.home-doodle__scene-bars,
.home-doodle__scene-orbital,
.home-doodle__scene-beam,
.home-doodle__scene-tickets,
.home-doodle__scene-sparks {
  position: absolute;
  z-index: 1;
}

.home-doodle__scene.is-three-ready .home-doodle__scene-aura,
.home-doodle__scene.is-three-ready .home-doodle__scene-ribbons,
.home-doodle__scene.is-three-ready .home-doodle__scene-bars,
.home-doodle__scene.is-three-ready .home-doodle__scene-orbital,
.home-doodle__scene.is-three-ready .home-doodle__scene-beam,
.home-doodle__scene.is-three-ready .home-doodle__scene-tickets,
.home-doodle__scene.is-three-ready .home-doodle__scene-sparks {
  opacity: 0;
}

.home-doodle__scene-aura {
  border-radius: 50%;
  filter: blur(46px);
  opacity: 0.72;
}

.home-doodle__scene-aura--cyan {
  top: 20%;
  right: 24%;
  width: 180px;
  height: 180px;
  background: radial-gradient(circle, rgba(105, 225, 242, 0.26), rgba(105, 225, 242, 0));
  animation: aura-drift 12s ease-in-out infinite;
}

.home-doodle__scene-aura--violet {
  top: 8%;
  right: 0;
  width: 210px;
  height: 210px;
  background: radial-gradient(circle, rgba(150, 119, 255, 0.24), rgba(150, 119, 255, 0));
  animation: aura-drift 14s ease-in-out infinite reverse;
}

.home-doodle__scene-ribbons {
  inset: 0;
}

.home-doodle__scene-ribbon {
  position: absolute;
  left: 10%;
  width: 82%;
  border-radius: 999px;
  transform-origin: center;
}

.home-doodle__scene-ribbon--one {
  top: 34%;
  height: 18px;
  background: linear-gradient(90deg, rgba(123, 216, 244, 0), rgba(123, 216, 244, 0.28), rgba(210, 224, 255, 0.34), rgba(152, 122, 255, 0));
  filter: blur(10px);
  transform: rotate(19deg);
  animation: ribbon-slide 11s ease-in-out infinite;
}

.home-doodle__scene-ribbon--two {
  top: 46%;
  height: 10px;
  background: linear-gradient(90deg, rgba(172, 247, 234, 0), rgba(172, 247, 234, 0.16), rgba(138, 122, 255, 0.24), rgba(172, 247, 234, 0));
  filter: blur(5px);
  transform: rotate(14deg);
  animation: ribbon-slide 13s ease-in-out infinite reverse;
}

.home-doodle__scene-ribbon--three {
  top: 58%;
  height: 6px;
  background: linear-gradient(90deg, rgba(238, 244, 255, 0), rgba(238, 244, 255, 0.14), rgba(139, 223, 216, 0.18), rgba(238, 244, 255, 0));
  filter: blur(2px);
  transform: rotate(16deg);
  animation: ribbon-slide 15s ease-in-out infinite;
}

.home-doodle__scene-bars {
  top: 28%;
  left: 13%;
  display: flex;
  gap: 12px;
  align-items: flex-end;
}

.home-doodle__scene-bars span {
  width: 10px;
  border-radius: 999px;
  background: linear-gradient(180deg, rgba(230, 237, 244, 0.82), rgba(118, 207, 221, 0.26));
  box-shadow: 0 0 18px rgba(128, 220, 235, 0.14);
  transform-origin: center bottom;
}

.home-doodle__scene-bars span:nth-child(1) { height: 52px; animation: scene-bar-lift 1.8s ease-in-out infinite; }
.home-doodle__scene-bars span:nth-child(2) { height: 78px; animation: scene-bar-lift 1.8s 0.16s ease-in-out infinite; }
.home-doodle__scene-bars span:nth-child(3) { height: 60px; animation: scene-bar-lift 1.8s 0.32s ease-in-out infinite; }
.home-doodle__scene-bars span:nth-child(4) { height: 90px; animation: scene-bar-lift 1.8s 0.48s ease-in-out infinite; }
.home-doodle__scene-bars span:nth-child(5) { height: 70px; animation: scene-bar-lift 1.8s 0.64s ease-in-out infinite; }

.home-doodle__scene-orbital {
  top: 4%;
  right: 2%;
  width: 230px;
  height: 230px;
  border-radius: 50%;
}

.home-doodle__scene-orbit {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 1px solid rgba(220, 229, 240, 0.22);
}

.home-doodle__scene-orbit--outer {
  animation: orbit-spin 12s linear infinite;
}

.home-doodle__scene-orbit--inner {
  inset: 42px;
  border-color: rgba(194, 205, 221, 0.26);
  animation: orbit-spin 8.4s linear infinite reverse;
}

.home-doodle__scene-core {
  position: absolute;
  inset: 74px;
  border-radius: 50%;
  background:
    radial-gradient(circle at 34% 30%, rgba(255, 255, 255, 0.92), rgba(223, 232, 243, 0.76) 46%, rgba(154, 171, 194, 0.18) 100%),
    rgba(255, 255, 255, 0.12);
  box-shadow:
    0 0 34px rgba(236, 240, 248, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

.home-doodle__scene-core::before {
  content: '';
  position: absolute;
  inset: -34px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(157, 126, 255, 0.18), rgba(157, 126, 255, 0));
  filter: blur(18px);
}

.home-doodle__scene-satellite {
  position: absolute;
  border-radius: 50%;
  border: 1px solid rgba(211, 220, 234, 0.26);
  background: rgba(255, 255, 255, 0.06);
}

.home-doodle__scene-satellite--one {
  right: -6px;
  bottom: 56px;
  width: 42px;
  height: 42px;
  animation: satellite-orbit 7.2s ease-in-out infinite;
}

.home-doodle__scene-satellite--two {
  left: 12px;
  bottom: 28px;
  width: 24px;
  height: 24px;
  animation: satellite-orbit 6.2s ease-in-out infinite reverse;
}

.home-doodle__scene-beam {
  top: 28%;
  right: 12%;
  width: 320px;
  height: 260px;
  clip-path: polygon(62% 0, 100% 8%, 64% 100%, 0 82%);
  background: linear-gradient(180deg, rgba(239, 245, 255, 0.22), rgba(130, 220, 239, 0.12) 42%, rgba(130, 220, 239, 0));
  filter: blur(2px);
  opacity: 0.62;
  animation: beam-sway 5.2s ease-in-out infinite;
}

.home-doodle__scene-tickets {
  position: absolute;
  right: 8%;
  bottom: 8%;
  width: 420px;
  height: 270px;
  transform-style: preserve-3d;
}

.home-doodle__scene-ticket {
  position: absolute;
  inset: auto 0 0 auto;
  width: 350px;
  height: 220px;
  border-radius: 36px;
  padding: 28px 28px 24px;
  background:
    linear-gradient(180deg, rgba(19, 24, 35, 0.9), rgba(8, 10, 17, 0.96)),
    rgba(10, 12, 18, 0.88);
  border: 1px solid rgba(207, 216, 229, 0.12);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 28px 46px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(28px) saturate(155%);
  -webkit-backdrop-filter: blur(28px) saturate(155%);
}

.home-doodle__scene-ticket--back {
  right: 54px;
  bottom: 74px;
  transform: rotate(-10deg) translateZ(-40px);
  opacity: 0.5;
  animation: ticket-float-back 8s ease-in-out infinite;
}

.home-doodle__scene-ticket--front {
  right: 0;
  bottom: 0;
  transform: rotate(8deg) translateZ(0);
  animation: ticket-float-front 6.4s ease-in-out infinite;
}

.home-doodle__scene-ticket-line {
  display: block;
  height: 10px;
  margin-bottom: 14px;
  border-radius: 999px;
  background: rgba(209, 218, 231, 0.24);
}

.home-doodle__scene-ticket-line--strong {
  width: 160px;
  background: rgba(241, 245, 251, 0.72);
}

.home-doodle__scene-ticket-line--short {
  width: 132px;
}

.home-doodle__scene-qr-shell {
  position: absolute;
  right: 28px;
  bottom: 26px;
  width: 152px;
  height: 152px;
  border-radius: 30px;
  background: rgba(15, 18, 25, 0.82);
  border: 1px solid rgba(215, 223, 236, 0.14);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 20px 32px rgba(0, 0, 0, 0.2);
}

.home-doodle__scene-qr-panel {
  position: absolute;
  inset: 18px;
  border-radius: 20px;
  background: rgba(6, 8, 14, 0.96);
  overflow: hidden;
}

.home-doodle__scene-qr-module {
  position: absolute;
  width: 5px;
  height: 5px;
  border-radius: 1px;
  background: #dde4ef;
}

.home-doodle__scene-qr-scan {
  position: absolute;
  left: 0;
  right: 0;
  top: 10px;
  height: 2px;
  background: rgba(236, 240, 247, 0.94);
  box-shadow: 0 0 12px rgba(236, 240, 247, 0.24);
  animation: qr-scan-alt 2.8s ease-in-out infinite;
}

.home-doodle__scene-sparks {
  inset: 0;
}

.home-doodle__scene-sparks span {
  position: absolute;
  border-radius: 50%;
  background: rgba(235, 241, 249, 0.62);
  box-shadow: 0 0 16px rgba(212, 220, 235, 0.24);
  animation: spark-pulse 3.4s ease-in-out infinite;
}

.home-doodle__scene-sparks span:nth-child(1) {
  width: 10px;
  height: 10px;
  left: 40%;
  bottom: 18%;
}

.home-doodle__scene-sparks span:nth-child(2) {
  width: 6px;
  height: 6px;
  left: 50%;
  bottom: 30%;
  animation-delay: 0.45s;
}

.home-doodle__scene-sparks span:nth-child(3) {
  width: 8px;
  height: 8px;
  right: 24%;
  bottom: 12%;
  animation-delay: 0.8s;
}

.scene-ribbon {
  fill: none;
  stroke-linecap: round;
  pointer-events: none;
}

.scene-aura {
  filter: blur(22px);
  opacity: 0.7;
  transform-origin: center;
}

.scene-aura--one {
  animation: aura-drift 11s ease-in-out infinite;
}

.scene-aura--two {
  animation: aura-drift 13s ease-in-out infinite reverse;
}

.scene-ribbon--one {
  stroke: rgba(136, 220, 236, 0.1);
  stroke-width: 18;
  filter: blur(10px);
  animation: ribbon-drift 10s ease-in-out infinite;
}

.scene-ribbon--two {
  stroke: rgba(186, 164, 255, 0.12);
  stroke-width: 10;
  filter: blur(6px);
  animation: ribbon-drift 12s ease-in-out infinite reverse;
}

.scene-ribbon--three {
  stroke: rgba(224, 234, 244, 0.08);
  stroke-width: 6;
  filter: blur(3px);
  animation: ribbon-drift 14s ease-in-out infinite;
}

.scene-sparks circle {
  fill: rgba(225, 233, 242, 0.5);
  animation: spark-pulse 3.4s ease-in-out infinite;
}

.scene-sparks circle:nth-child(2) {
  animation-delay: 0.45s;
}

.scene-sparks circle:nth-child(3) {
  animation-delay: 0.8s;
}

.home-doodle__content {
  position: relative;
  z-index: 1;
  isolation: isolate;
  min-height: inherit;
  max-width: min(1220px, 82%);
  display: grid;
  align-content: center;
  justify-items: start;
  gap: 14px;
}

.home-doodle__content::before {
  content: '';
  position: absolute;
  inset: -34px -190px -62px -30px;
  z-index: -1;
  border-radius: 42px;
  background:
    radial-gradient(circle at 24% 28%, rgba(8, 8, 12, 0.96), rgba(8, 8, 12, 0.78) 46%, transparent 82%),
    linear-gradient(90deg, rgba(8, 8, 12, 0.58), rgba(8, 8, 12, 0.1));
  filter: blur(18px);
}

.home-doodle__eyebrow {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  color: rgba(236, 238, 244, 0.9);
  background: linear-gradient(180deg, rgba(24, 22, 31, 0.7), rgba(8, 8, 12, 0.84));
  border: 1px solid rgba(228, 231, 238, 0.14);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.1),
    0 14px 30px rgba(2, 4, 10, 0.28);
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  backdrop-filter: blur(18px);
}

.home-doodle__title {
  width: min(100%, 840px);
  margin: 0;
  text-align: left;
  color: transparent;
  background: linear-gradient(180deg, #ffffff 0%, #f0f4fa 40%, #ccd5e3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  font-family: 'Cormorant Garamond', serif;
  font-size: clamp(3.3rem, 4.4vw, 5rem);
  font-weight: 600;
  line-height: 0.92;
  letter-spacing: -0.045em;
  text-shadow: 0 16px 36px rgba(8, 12, 24, 0.34);
}

.home-doodle__title-line {
  display: block;
  text-align: left;
}

.home-doodle__statement {
  width: min(100%, 760px);
  margin: 0;
  text-align: left;
  color: rgba(235, 240, 247, 0.96);
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: clamp(1.04rem, 1.42vw, 1.32rem);
  font-weight: 760;
  line-height: 1.04;
  letter-spacing: -0.03em;
  text-shadow: 0 10px 24px rgba(6, 9, 18, 0.34);
}

.home-doodle__statement-line {
  display: block;
  text-align: left;
}

.home-doodle__subtitle {
  width: min(100%, 820px);
  margin: 0;
  text-align: left;
  color: rgba(191, 198, 211, 0.82);
  font-family: 'Manrope', sans-serif;
  font-size: 0.95rem;
  font-weight: 500;
  line-height: 1.56;
}

.home-doodle__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.home-doodle__meta-pill {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 0 14px;
  border-radius: 999px;
  color: rgba(232, 235, 243, 0.9);
  background: linear-gradient(180deg, rgba(20, 18, 28, 0.68), rgba(8, 8, 12, 0.78));
  border: 1px solid rgba(226, 230, 238, 0.1);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    inset 0 -10px 18px rgba(108, 84, 145, 0.06);
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.74rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  backdrop-filter: blur(18px);
}

.home-doodle__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  padding-top: 10px;
}

.home-doodle__action {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  appearance: none;
  border: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 240px;
  min-height: 56px;
  padding: 0;
  border-radius: 999px;
  cursor: pointer;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #eef3fa;
  background: rgba(10, 10, 14, 0.16);
  backdrop-filter: blur(34px) saturate(135%);
  -webkit-backdrop-filter: blur(34px) saturate(135%);
  transition:
    transform 180ms ease,
    box-shadow 180ms ease,
    filter 180ms ease;
}

.home-doodle__action::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0.08) 16%, rgba(91, 154, 171, 0.06) 54%, rgba(255, 255, 255, 0.1) 100%);
  opacity: 0.32;
  pointer-events: none;
}

.home-doodle__action::after {
  content: '';
  position: absolute;
  inset: 1px;
  border-radius: inherit;
  background:
    radial-gradient(circle at 24% -12%, rgba(255, 255, 255, 0.28), transparent 34%),
    radial-gradient(circle at 86% 88%, rgba(83, 149, 164, 0.12), transparent 26%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03) 22%, rgba(12, 12, 18, 0.03) 54%, rgba(102, 185, 180, 0.05) 100%);
  opacity: 0.72;
  pointer-events: none;
}

.home-doodle__action-glow {
  position: absolute;
  inset: -28%;
  border-radius: inherit;
  background:
    radial-gradient(circle at 18% 10%, rgba(255, 255, 255, 0.14), transparent 30%),
    radial-gradient(circle at 68% 86%, rgba(79, 145, 160, 0.18), transparent 42%);
  filter: blur(24px);
  opacity: 0.34;
  pointer-events: none;
}

.home-doodle__action-ring {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.26), rgba(255, 255, 255, 0.04) 26%, rgba(83, 149, 164, 0.04) 60%, rgba(255, 255, 255, 0.12) 84%, rgba(122, 206, 199, 0.08) 100%);
  opacity: 0.68;
  pointer-events: none;
}

.home-doodle__action-inner {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  width: calc(100% - 2px);
  min-height: 54px;
  margin: 1px;
  padding: 0 10px 0 18px;
  border-radius: inherit;
  background:
    radial-gradient(circle at 24% 0%, rgba(255, 255, 255, 0.12), transparent 34%),
    linear-gradient(180deg, rgba(24, 37, 46, 0.18), rgba(12, 12, 18, 0.34));
  color: #eef1f7;
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    inset 0 -16px 24px rgba(93, 185, 177, 0.06),
    0 0 0 1px rgba(255, 255, 255, 0.03);
}

.home-doodle__action-copy {
  white-space: nowrap;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.08);
}

.home-doodle__action-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  color: #f4f7fb;
  background:
    radial-gradient(circle at 30% 24%, rgba(255, 255, 255, 0.22), transparent 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(83, 149, 164, 0.08));
  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.22),
    inset 0 -8px 14px rgba(94, 171, 165, 0.08),
    0 8px 18px rgba(4, 6, 12, 0.14);
  transition: transform 180ms ease, box-shadow 180ms ease, background 180ms ease;
}

.home-doodle__action--primary {
  box-shadow:
    0 18px 34px rgba(2, 4, 10, 0.3),
    0 10px 18px rgba(71, 147, 158, 0.14);
}

.home-doodle__action--primary .home-doodle__action-glow {
  inset: -10px;
  background:
    radial-gradient(circle at 16% 10%, rgba(228, 232, 239, 0.16), transparent 28%),
    radial-gradient(circle at 82% 84%, rgba(93, 185, 177, 0.18), transparent 34%);
  filter: blur(14px);
  opacity: 0.22;
}

.home-doodle__action--primary .home-doodle__action-ring {
  inset: 1px;
  background:
    radial-gradient(circle at 18% 12%, rgba(255, 255, 255, 0.22), transparent 26%),
    linear-gradient(135deg, rgba(255, 255, 255, 0.14), rgba(255, 255, 255, 0.04) 26%, rgba(92, 184, 176, 0.08) 60%, rgba(255, 255, 255, 0.12) 100%);
  opacity: 0.78;
}

.home-doodle__action--primary::after {
  inset: 1px;
  background:
    linear-gradient(180deg, rgba(255, 255, 255, 0.08), transparent 20%),
    radial-gradient(circle at 12% 0%, rgba(255, 255, 255, 0.08), transparent 22%);
  opacity: 0.22;
}

.home-doodle__action--primary .home-doodle__action-inner {
  width: calc(100% - 4px);
  min-height: 52px;
  margin: 2px;
  background:
    radial-gradient(circle at 18% 0%, rgba(255, 255, 255, 0.1), transparent 34%),
    linear-gradient(180deg, rgba(24, 39, 48, 0.3), rgba(11, 11, 17, 0.68));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.12),
    inset 0 -16px 24px rgba(93, 185, 177, 0.08),
    0 0 0 1px rgba(255, 255, 255, 0.04);
}

.home-doodle__action--primary .home-doodle__action-icon {
  background:
    radial-gradient(circle at 30% 24%, rgba(255, 255, 255, 0.24), transparent 34%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.14), rgba(95, 177, 171, 0.14));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.26),
    inset 0 -8px 14px rgba(93, 185, 177, 0.14),
    0 8px 18px rgba(4, 6, 12, 0.16);
}

.home-doodle__action--secondary {
  box-shadow:
    0 16px 30px rgba(2, 4, 10, 0.24),
    0 10px 18px rgba(71, 147, 158, 0.08);
}

.home-doodle__action--secondary .home-doodle__action-glow {
  opacity: 0.24;
}

.home-doodle__action--secondary .home-doodle__action-ring {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0.06) 20%, rgba(90, 171, 166, 0.06) 52%, rgba(255, 255, 255, 0.14) 80%, rgba(122, 206, 199, 0.09) 100%);
}

.home-doodle__action--secondary .home-doodle__action-inner {
  background:
    radial-gradient(circle at 24% 0%, rgba(255, 255, 255, 0.09), transparent 34%),
    linear-gradient(180deg, rgba(22, 33, 42, 0.14), rgba(10, 10, 16, 0.34));
}

@media (hover: hover) {
  .home-doodle__action:hover {
    transform: none;
    filter: brightness(1.03);
  }

  .home-doodle__action:hover .home-doodle__action-glow {
    opacity: 0.72;
  }

  .home-doodle__action:hover .home-doodle__action-icon {
    transform: none;
    box-shadow:
      inset 0 1px 0 rgba(255, 255, 255, 0.28),
      0 12px 22px rgba(4, 8, 18, 0.24);
  }
}

.home-doodle__action:active {
  transform: translateY(0);
}

.scene-lights circle,
.scene-lights path,
.scene-singer__platform,
.scene-singer__body,
.scene-singer__arm,
.scene-singer__mic,
.scene-crowd path,
.scene-crowd circle,
.scene-bars rect {
  fill: none;
  stroke: rgba(205, 212, 226, 0.34);
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.scene-lights circle {
  fill: rgba(210, 218, 232, 0.08);
}

.scene-scanner__halo {
  fill: rgba(135, 116, 182, 0.12);
}

.scene-scanner__ring {
  fill: rgba(14, 13, 22, 0.9);
  stroke: rgba(207, 214, 227, 0.28);
  stroke-width: 1.5;
}

.scene-scanner__core {
  fill: rgba(231, 236, 244, 0.94);
  filter: drop-shadow(0 0 14px rgba(220, 225, 235, 0.28));
}

.scene-scanner__orbit {
  fill: none;
  stroke: rgba(189, 197, 212, 0.1);
  stroke-width: 1;
  stroke-dasharray: 10 12;
  animation: orbit-spin 10s linear infinite;
  transform-origin: 1118px 156px;
}

.scene-scanner__beam {
  fill: rgba(213, 219, 230, 0.1);
  filter: drop-shadow(0 0 26px rgba(181, 189, 207, 0.22));
  animation: beam-pulse 3.8s ease-in-out infinite;
}

.scene-ticket__body {
  fill: rgba(17, 14, 26, 0.92);
  stroke: rgba(179, 186, 201, 0.18);
  stroke-width: 1.1;
}

.scene-ticket--back {
  opacity: 0.42;
  animation: ticket-drift-back 6.8s ease-in-out infinite;
}

.scene-ticket--front {
  animation: ticket-drift-front 5.8s ease-in-out infinite;
}

.scene-ticket__line {
  fill: rgba(170, 177, 192, 0.26);
}

.scene-ticket__line--strong {
  fill: rgba(226, 231, 240, 0.56);
}

.scene-ticket__shine {
  fill: rgba(255, 255, 255, 0.14);
  filter: blur(2px);
}

.scene-ticket__qr-frame {
  fill: rgba(8, 8, 12, 0.34);
  stroke: rgba(196, 203, 215, 0.26);
  stroke-width: 1.05;
}

.scene-ticket__qr-surface {
  fill: rgba(8, 8, 12, 0.96);
}

.scene-ticket__qr-module {
  fill: #d8dde7;
}

.scene-ticket__scan-line {
  fill: none;
  stroke: rgba(236, 240, 247, 0.96);
  stroke-width: 1.35;
  stroke-linecap: round;
  filter: drop-shadow(0 0 10px rgba(210, 217, 230, 0.34));
  animation: qr-scan 2.8s ease-in-out infinite;
}

.scene-ticket__scan-corner,
.scene-singer__head,
.scene-singer__mic-head {
  fill: none;
  stroke: rgba(196, 203, 215, 0.84);
  stroke-width: 1.45;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.scene-singer__head,
.scene-singer__mic-head {
  fill: rgba(18, 16, 28, 0.88);
  stroke-width: 2.1;
}

.scene-singer__platform {
  animation: stage-pulse 4.2s ease-in-out infinite;
}

.scene-singer__body,
.scene-singer__arm,
.scene-singer__mic,
.scene-singer__head,
.scene-singer__mic-head {
  animation: singer-sway 5.2s ease-in-out infinite;
  transform-origin: 312px 460px;
}

.scene-crowd circle,
.scene-crowd path {
  animation: crowd-bounce 2.8s ease-in-out infinite;
}

.scene-crowd circle:nth-child(2),
.scene-crowd path:nth-child(6) {
  animation-delay: 0.2s;
}

.scene-crowd circle:nth-child(3),
.scene-crowd path:nth-child(7) {
  animation-delay: 0.35s;
}

.scene-bars rect:nth-child(1) {
  animation: bar-pulse 1.6s ease-in-out infinite;
}

.scene-bars rect:nth-child(2) {
  animation: bar-pulse 1.6s 0.15s ease-in-out infinite;
}

.scene-bars rect:nth-child(3) {
  animation: bar-pulse 1.6s 0.3s ease-in-out infinite;
}

.scene-bars rect:nth-child(4) {
  animation: bar-pulse 1.6s 0.45s ease-in-out infinite;
}

.scene-bars rect:nth-child(5) {
  animation: bar-pulse 1.6s 0.6s ease-in-out infinite;
}

@keyframes stage-pulse {
  0%,
  100% {
    opacity: 0.36;
  }
  50% {
    opacity: 0.72;
  }
}

@keyframes singer-sway {
  0%,
  100% {
    transform: rotate(-1deg) translateY(0);
  }
  50% {
    transform: rotate(1deg) translateY(-3px);
  }
}

@keyframes crowd-bounce {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.42;
  }
  50% {
    transform: translateY(-6px);
    opacity: 0.78;
  }
}

@keyframes bar-pulse {
  0%,
  100% {
    opacity: 0.32;
    transform: scaleY(0.72);
    transform-origin: center bottom;
  }
  50% {
    opacity: 0.9;
    transform: scaleY(1.08);
    transform-origin: center bottom;
  }
}

@keyframes scene-bar-lift {
  0%,
  100% {
    transform: scaleY(0.78);
    opacity: 0.38;
  }
  50% {
    transform: scaleY(1.12);
    opacity: 0.96;
  }
}

@keyframes ribbon-slide {
  0%,
  100% {
    transform: rotate(16deg) translate3d(0, 0, 0) scaleX(1);
    opacity: 0.6;
  }
  50% {
    transform: rotate(13deg) translate3d(16px, -10px, 0) scaleX(1.04);
    opacity: 1;
  }
}

@keyframes beam-sway {
  0%,
  100% {
    transform: translate3d(0, 0, 0) rotate(0deg);
    opacity: 0.5;
  }
  50% {
    transform: translate3d(12px, -8px, 0) rotate(1.5deg);
    opacity: 0.82;
  }
}

@keyframes satellite-orbit {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.5;
  }
  50% {
    transform: translate3d(12px, -10px, 0) scale(1.1);
    opacity: 1;
  }
}

@keyframes ticket-float-front {
  0%,
  100% {
    transform: rotate(8deg) translate3d(0, 0, 0);
  }
  50% {
    transform: rotate(5deg) translate3d(-10px, -14px, 0);
  }
}

@keyframes ticket-float-back {
  0%,
  100% {
    transform: rotate(-10deg) translate3d(0, 0, 0);
  }
  50% {
    transform: rotate(-13deg) translate3d(8px, 10px, 0);
  }
}

@keyframes qr-scan-alt {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.2;
  }
  20% {
    opacity: 1;
  }
  50% {
    transform: translateY(72px);
    opacity: 1;
  }
  80% {
    opacity: 0.3;
  }
}

@keyframes qr-scan {
  0%,
  100% {
    transform: translateY(0);
    opacity: 0.22;
  }
  20% {
    opacity: 1;
  }
  50% {
    transform: translateY(60px);
    opacity: 1;
  }
  80% {
    opacity: 0.34;
  }
}

@keyframes ticket-drift-front {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-6px) rotate(-0.5deg);
  }
}

@keyframes ticket-drift-back {
  0%,
  100% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(6px) rotate(0.55deg);
  }
}

@keyframes orbit-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes beam-pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.92;
  }
}

@keyframes ribbon-drift {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.6;
  }
  50% {
    transform: translate3d(10px, -12px, 0) scale(1.03);
    opacity: 1;
  }
}

@keyframes aura-drift {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
    opacity: 0.54;
  }
  50% {
    transform: translate3d(12px, -16px, 0) scale(1.08);
    opacity: 0.86;
  }
}

@keyframes spark-pulse {
  0%,
  100% {
    opacity: 0.24;
    transform: scale(0.82);
  }
  50% {
    opacity: 0.82;
    transform: scale(1.12);
  }
}

@keyframes doodle-ring {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1100px) {
  .home-doodle__scene {
    right: -10%;
    width: min(62%, 620px);
    opacity: 0.94;
  }

  .home-doodle__content {
    max-width: min(980px, 84%);
  }

  .home-doodle__title {
    width: min(100%, 760px);
    font-size: clamp(2.9rem, 4vw, 4.25rem);
  }

  .home-doodle__statement {
    width: min(100%, 680px);
    font-size: clamp(0.98rem, 1.28vw, 1.18rem);
  }

  .home-doodle__subtitle {
    width: min(100%, 720px);
    font-size: 0.92rem;
  }

  .home-doodle__scene {
    transform: translateY(-48%);
  }
}

@media (max-width: 720px) {
  .home-doodle {
    padding-bottom: 2px;
  }

  .home-doodle__frame {
    min-height: 292px;
    padding: 14px 14px 12px;
  }

  .home-doodle__scene {
    top: auto;
    right: -34%;
    bottom: -14%;
    width: 88%;
    opacity: 0.54;
    transform: none;
    mask-image: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.12) 10%, rgba(0, 0, 0, 0.94) 44%, #000 60%);
    -webkit-mask-image: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.12) 10%, rgba(0, 0, 0, 0.94) 44%, #000 60%);
  }

  .home-doodle__content {
    max-width: min(64%, 270px);
    width: min(64%, 270px);
    min-height: 0;
    align-content: start;
    gap: 8px;
  }

  .home-doodle__content::before {
    inset: -12px -12px -18px -10px;
    background:
      linear-gradient(180deg, rgba(8, 8, 12, 0.96), rgba(8, 8, 12, 0.84) 58%, rgba(8, 8, 12, 0.34) 100%),
      radial-gradient(circle at 30% 18%, rgba(8, 8, 12, 0.8), transparent 72%);
  }

  .home-doodle__eyebrow {
    min-height: 28px;
    padding: 0 10px;
    font-size: 0.56rem;
    letter-spacing: 0.14em;
  }

  .home-doodle__title {
    width: min(9ch, 100%);
    font-size: clamp(1.85rem, 8.8vw, 2.3rem);
    line-height: 0.92;
  }

  .home-doodle__statement {
    width: min(15ch, 100%);
    font-size: clamp(0.88rem, 3.7vw, 1rem);
    line-height: 1.08;
  }

  .home-doodle__subtitle {
    width: min(25ch, 100%);
    font-size: 0.74rem;
    line-height: 1.32;
  }

  .home-doodle__meta {
    gap: 6px;
  }

  .home-doodle__meta-pill {
    width: auto;
    min-height: 28px;
    padding: 0 10px;
    font-size: 0.66rem;
  }

  .home-doodle__actions {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 0.92fr);
    gap: 8px;
    padding-top: 4px;
    width: 100%;
  }

  .home-doodle__action {
    width: 100%;
    min-width: 0;
    min-height: 44px;
    font-size: 0.76rem;
  }

  .home-doodle__action-inner {
    min-height: 42px;
    gap: 8px;
    padding: 0 8px 0 12px;
  }

  .home-doodle__action-icon {
    flex-basis: 28px;
    width: 28px;
    height: 28px;
    font-size: 0.76rem;
  }

  .home-doodle__scene {
    aspect-ratio: 740 / 540;
  }
}
</style>
